import request from './../utils/request'

export function index(params) {
    return request({
        url: '/PatientResidenceReport',
        method: 'get',
        params
    })
}

export function show(params) {
    return request({
        url: '/PatientResidenceReport/services',
        method: 'get',
        params
    })
}
